import { useState } from "react";
import { Truck, ExternalLink, Search } from "lucide-react";
import { toast } from "sonner";

const TRACK_PROVIDER = "https://t.17track.net/en#nums=";

export default function OrderTracking() {
  const [tracking, setTracking] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const code = tracking.trim();
    if (!code) {
      toast.error("Saisissez un numéro de suivi.");
      return;
    }
    window.open(`${TRACK_PROVIDER}${encodeURIComponent(code)}`, "_blank", "noopener");
  };

  return (
    <div className="max-w-4xl mx-auto px-6 md:px-12 py-12" data-testid="order-tracking-page">
      <div className="border-b border-white/10 pb-8 mb-12">
        <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#C5CDD8]">
          Service client
        </div>
        <h1 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tighter text-white">
          Suivi de commande
        </h1>
        <p className="mt-4 text-base text-white/60 max-w-xl">
          Saisissez le numéro de suivi reçu par email après l'expédition de
          votre commande pour visualiser sa progression en temps réel via notre
          partenaire 17track.
        </p>
      </div>

      <div className="grid lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2">
          <form onSubmit={submit} className="space-y-6" data-testid="tracking-form">
            <label className="block">
              <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#C5CDD8]">
                Numéro de suivi
              </span>
              <div className="mt-2 flex items-center gap-3 border-b border-white/40 focus-within:border-white">
                <Search size={16} strokeWidth={1.5} className="text-white/60" />
                <input
                  type="text"
                  required
                  placeholder="ex : NS123456789FR"
                  value={tracking}
                  onChange={(e) => setTracking(e.target.value)}
                  className="flex-1 bg-transparent text-white py-3 text-sm focus:outline-none"
                  data-testid="tracking-input"
                />
              </div>
            </label>

            <button
              type="submit"
              className="inline-flex items-center gap-2 border border-white bg-white text-[#001F3F] hover:bg-transparent hover:text-white transition-all uppercase tracking-[0.25em] text-xs font-bold px-8 py-4"
              data-testid="tracking-submit"
            >
              Suivre ma commande <ExternalLink size={14} />
            </button>

            <p className="text-xs text-white/60">
              Vous serez redirigé·e vers <strong className="text-white">17track</strong>,
              service de suivi universel reconnu (700+ transporteurs).
            </p>
          </form>
        </div>

        <aside className="lg:col-span-1 space-y-6">
          <div className="border border-white/15 bg-[#0A2A4F] p-6">
            <Truck size={22} strokeWidth={1.25} className="text-[#C5CDD8]" />
            <div className="mt-3 text-[10px] font-bold uppercase tracking-[0.3em] text-[#C5CDD8]">
              Vous n'avez pas votre numéro ?
            </div>
            <p className="mt-2 text-sm text-white/70 leading-relaxed">
              Le numéro de suivi est envoyé par email dans les 24-48h après la
              validation du paiement. Vérifiez votre boîte de spam, ou écrivez-nous.
            </p>
            <a
              href="mailto:nordstellatech@gmail.com"
              className="mt-4 inline-block text-xs font-bold uppercase tracking-widest text-white underline"
              data-testid="tracking-contact-email"
            >
              nordstellatech@gmail.com
            </a>
          </div>
        </aside>
      </div>
    </div>
  );
}
